module.exports = __webpack_public_path__ + "media/press/img1-5d3dc157.png";